/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import { defineMessages } from 'react-intl';
import { browserName } from 'react-device-detect';
import fetch from 'isomorphic-fetch';

import Home from './Home';
import { clearBooking } from '../../actions/booking';
import Layout from '../../components/Layout';

const messages = defineMessages({
  homeMetaTitle: {
    id: 'home_meta_title',
    defaultMessage: '##Red Planet Hotels - Great location, Unbeatable value##',
    description: 'Meta Title Head',
  },
  title: {
    id: 'title.home',
    defaultMessage: '##Red Planet Hotels - Great location, Unbeatable value##',
    description: 'Title Head',
  },
});

async function action({ meta, intl, store, apiUrl }) {
  await store.dispatch(clearBooking());
  const respPopup = await fetch(`${apiUrl}initial_app`);
  const dataPopup = await respPopup.json();
  return {
    chunks: ['home'],
    metaTitle: meta[intl.locale].home_meta_title
      ? meta[intl.locale].home_meta_title.message
      : intl.formatMessage(messages.homeMetaTitle),
    forcedTitle: meta[intl.locale].home_title
      ? meta[intl.locale].home_title.message
      : intl.formatMessage(messages.title),
    description: meta[intl.locale].home_meta_description
      ? meta[intl.locale].home_meta_description.message
      : '',
    titleBody: meta[intl.locale].home_title_body
      ? meta[intl.locale].home_title_body.message
      : '',
    component: (
      <Layout dataPopup={dataPopup.data}>
        <Home browserName={`${browserName}`} />
      </Layout>
    ),
  };
}

export default action;
